"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ModeToggle } from "./mode-toggle";
import UserMenu from "./user-menu";
export default function Header() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      to: "/",
      label: "Home"
    }, {
      to: "/dashboard",
      label: "Dashboard"
    }, {
      to: "/chats",
      label: "Chat"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const links = t0 as const;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <nav className="flex gap-4 text-lg">{links.map(_temp)}</nav>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><div className="flex flex-row items-center justify-between px-2 py-1">{t1}<div className="flex items-center gap-2"><ModeToggle /><UserMenu /></div></div><hr /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(t0) {
  const {
    to,
    label
  } = t0;
  return <Link key={to} href={to}>{label}</Link>;
}